import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { ComparisonMetric } from './resolution-integrity-types';
export function useMetricLabel() {
  const $ = _c(2);
  const t = useTranslations("market.resolutionIntegrity");
  let t0;
  if ($[0] !== t) {
    t0 = metric => {
      switch (metric) {
        case "averagePosition":
          {
            return t("metricAveragePosition");
          }
        case "holders":
          {
            return t("metricHolders");
          }
        case "volume":
          {
            return t("metricVolume");
          }
        case "largestHolderShare":
          {
            return t("metricLargestHolder");
          }
        case "top5HoldersShare":
          {
            return t("metricTop5Holders");
          }
        case "finalHourNetInflow":
          {
            return t("metricFinalHour");
          }
      }
    };
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}